import { createSlice } from '@reduxjs/toolkit'

import type { RootState } from '../store'
import { Institution } from '../../graphql/generated/graphql'
import { getCustomService } from '../../helpers/ReduxHelpers'

import { actionTypes } from './types'

export const name = 'institutions'

export const institutionsService = getCustomService<'institutions', Array<Institution>>(
  'institutions'
)

export type InstitutionState = {
  institution: Institution | null
  institutions: typeof institutionsService.state
}

//
// Initial state
//

const initialState: InstitutionState = {
  institution: null,
  institutions: institutionsService.state,
}

//
// Slice (Actions & Reducers)
//

const slice = createSlice({
  name,
  initialState,
  reducers: {
    setInstitution: (state: InstitutionState, action: actionTypes.setInstitution) => {
      const { institution } = action.payload
      state.institution = institution
    },
    ...institutionsService.reducers,
  },
})

export const { reducer, actions } = slice

//
// Selectors
//

const root = (state: RootState) => state[name]
const institution = (state: RootState) => root(state).institution
const institutions = (state: RootState) => root(state).institutions

export const selectors = {
  institution,
  institutions,
}
